module.exports = __webpack_public_path__ + "static/fonts/fzqkbysjt.1d5f00f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/font/fzqkbysjt.ttf
// module id = 6VDG
// module chunks = 130